import gsap from 'gsap'

/**
 * Page Fade-In Animation
 * 
 * Fades in the entire page once JavaScript is loaded and ready.
 * This prevents flash of unstyled content and ensures animations
 * are ready before the page becomes visible.
 */

export function initPageFadeIn() {
  // Small delay to ensure all scripts are loaded
  setTimeout(() => {
    // Fade in the page and fade out the overlay together
    const tl = gsap.timeline({
      onComplete: () => {
        // Add class to indicate page is loaded
        document.body.classList.add('page-loaded')
      }
    })
  }, 100)
}

export function initPageFadeOut() {
  // Create white overlay element if it doesn't exist
  let overlay = document.getElementById('page-fade-overlay')

  // Handle link clicks
  document.addEventListener('click', (e) => {
    const link = e.target.closest('a')
    
    // Only handle internal links (same origin)
    if (!link) return
    if (!link.href) return
    
    // Skip if it's a special link (javascript:, mailto:, tel:, etc.)
    const href = link.getAttribute('href')
    if (!href || href.startsWith('javascript:') || 
        href.startsWith('mailto:') || href.startsWith('tel:') || 
        link.hasAttribute('download') || link.target === '_blank') {
      return
    }

    // Skip if cmd/ctrl/shift/meta key is pressed
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) {
      return
    }

    // Check if it's an internal link
    try {
      const linkUrl = new URL(link.href, window.location.origin)
      const currentUrl = new URL(window.location.href)
      
      // Skip if it's a hash link (starts with # or same page with hash)
      const isHashLink = href.startsWith('#') || 
        (linkUrl.origin === currentUrl.origin && 
         linkUrl.pathname === currentUrl.pathname && 
         linkUrl.hash !== '')
      
      if (isHashLink) {
        // Allow normal hash link behavior (browser will scroll)
        return
      }
      
      // Only fade out for same-origin navigation to different pages
      if (linkUrl.origin === currentUrl.origin) {
        e.preventDefault()
        
        // Set flag so next page knows we're navigating
        sessionStorage.setItem('page-navigating', 'true')
        document.body.classList.add('page-loading')
        
        // Fade out body and fade in overlay
        const tl = gsap.timeline({
          onComplete: () => {
            // Navigate after fade completes
            window.location.href = link.href
          }
        })

        // Fade out body
        tl.to('body', {
          opacity: 0,
          duration: 0.3,
          ease: 'power2.in'
        }, 0)

        // Fade in overlay
        tl.to(overlay, {
          opacity: 1,
          duration: 0.3,
          ease: 'power2.in'
        }, 0)
      }
    } catch (error) {
      // If URL parsing fails, allow normal navigation
      return
    }
  })

  // Handle back/forward button (BFCache restore)
  window.addEventListener('pageshow', (e) => {
    if (e.persisted) {
      document.body.classList.remove('page-loading')
      document.body.style.opacity = ''
      if (overlay) overlay.style.opacity = ''
    }
  })
}